import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TrialVisit } from 'src/app/models/checkin';
import { CheckinService } from 'src/app/services/checkin/checkin.service';
import { EnrollService } from 'src/app/services/enroll/enroll.service';

/**
 * Back office page "Probestunden": visits of the last 8 weeks without an
 * enrollment (trial lessons via app check-in or the visits view). "Eintragen"
 * enrolls the student from the first trial visit; the visits then count as
 * regular visits.
 */
@Component({
  selector: 'li-trials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './trials.component.html',
  styleUrls: ['./trials.component.scss']
})
export class TrialsComponent implements OnInit {
  public trials: TrialVisit[] = [];
  public loading = true;

  constructor(
    private checkinService: CheckinService,
    private enrollService: EnrollService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  public enroll(trial: TrialVisit): void {
    this.enrollService.add(trial.sid, trial.cid, trial.first, '2100-01-01').subscribe({
      next: () => this.load(),
      error: () => alert(`${trial.firstname} ${trial.lastname} konnte nicht eingetragen werden.`)
    });
  }

  private load(): void {
    this.loading = true;
    this.checkinService.trials().subscribe({
      next: trials => {
        this.trials = trials;
        this.loading = false;
      },
      error: () => {
        this.trials = [];
        this.loading = false;
      }
    });
  }
}
